<template>
  <BaseCard>
    <div class="content">
      <div class="text">Loading</div>
      <BaseSpinner />
    </div>
  </BaseCard>
</template>

<script>
import BaseCard from '@/components/BaseCard/BaseCard'
import BaseSpinner from '@/components/BaseSpinner/BaseSpinner'
export default {
  components: {
    BaseCard,
    BaseSpinner
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6rem;
}
.text {
  color: var(--color-gray-3);
  font-weight: var(--fw-medium);
  margin-right: 6px;
}
</style>
